export default __webpack_public_path__ + "static/media/peach.590c1a30.jpg";